import React from "react";
import Container from "olive-react-myoneui/lib/Container";
import Row from "olive-react-myoneui/lib/Row";
import Col from "olive-react-myoneui/lib/Col";
import BundleCourseItem from "./BundleCourseItem";

function BundleCourses() {  
  return (
    <Container>
      <Row className="py-4">
        <Col lg={3} className="mb-3">
          <BundleCourseItem />
        </Col>
        <Col lg={3} className="mb-3">
          <BundleCourseItem />
        </Col>
        <Col lg={3} className="mb-3">
          <BundleCourseItem />
        </Col>
        <Col lg={3} className="mb-3">
          <BundleCourseItem />
        </Col>
      </Row>
    </Container>
  );
}

export default BundleCourses;
